export default "__VITE_ASSET__BHElLYCS__"